import { observer } from "mobx-react-lite"

import type { ClFarmsAlmType } from "@/domains/cl-farms-page/types"
import { Search } from "@/components/search"
import { Switch } from "@/components/switch"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { ClFarmAlmUiType } from "@/domains/cl-farms-page/cl-farms-page-store"
import { ClFarmsAlmTabs } from "@/domains/cl-farms-page/components/cl-farms-alm-tabs"
import { SwitchDetailedMode } from "@/domains/common/components/switches/switch-detailed-mode"
import { SwitchMyPositions } from "@/domains/common/components/switches/switch-my-positions"
import { CompactIcon } from "@/domains/icons"
import { useGovernanceToken } from "@/hooks/use-governance-token"
import { useNativeToken } from "@/hooks/use-native-token"
import useResponsive from "@/hooks/use-responsive"

import { MobileView } from "./mobile-view"

export const ALM_TABS: Array<ClFarmsAlmType> = ["Fertilizer", "Gamma", "Ichi"] // no steer on base "Steer"

export const ClFarmsTableParams = observer(() => {
  const scaleApp = useScaleApplication()
  const nativeToken = useNativeToken()
  const governanceToken = useGovernanceToken()
  const { isMobile } = useResponsive()

  const onAlmValueChange = (value: ClFarmAlmUiType) => scaleApp.Pages.ClFarms.setAlmFromUi(value)

  if (isMobile) {
    return <MobileView />
  }

  return (
    <>
      <div className="hidden w-full justify-start gap-4 lg:flex">
        <div className="text-t200 flex w-[30%] items-center gap-3">
          <Search
            className="text-t200 w-full max-w-[640px]"
            placeholder={`${governanceToken.name}, ${nativeToken.name}, BTC, ETH, 0x...`}
            value={scaleApp.Pages.ClFarms.search}
            onChange={(e) => scaleApp.Pages.ClFarms.setSearchFromUi(e.target.value)}
          />
        </div>
        <SwitchDetailedMode
          checked={scaleApp.Pages.ClFarms.isDetailed}
          onCheckedChange={(value) => scaleApp.Pages.ClFarms.setIsDetailedFromUi(value)}
        />
        <SwitchMyPositions
          checked={scaleApp.Pages.ClFarms.stakedOnly}
          onCheckedChange={(value) => scaleApp.Pages.ClFarms.setStakedOnlyFromUi(value)}
        />
        <div className="text-t200 ml-auto flex w-fit items-center gap-3">
          <ClFarmsAlmTabs
            value={scaleApp.Pages.ClFarms.alm}
            onValueChange={onAlmValueChange}
            availableTabs={ALM_TABS}
            className=""
          />
        </div>
      </div>
    </>
  )
})
